import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { AccordionModule } from "primeng/accordion";
import { ButtonModule } from "primeng/button";
import { CalendarModule } from "primeng/calendar";
import { CardModule } from "primeng/card";
import { ChartModule } from "primeng/chart";
import { CheckboxModule } from "primeng/checkbox";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DialogModule } from "primeng/dialog";
import { DragDropModule } from "primeng/dragdrop";
import { DropdownModule } from "primeng/dropdown";
import { DynamicDialogModule } from "primeng/dynamicdialog";
import { EditorModule } from "primeng/editor";
import { FileUploadModule } from "primeng/fileupload";
import { InputMaskModule } from "primeng/inputmask";
import { InputSwitchModule } from "primeng/inputswitch";
import { InputTextModule } from "primeng/inputtext";
import { MenuModule } from "primeng/menu";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { PanelModule } from "primeng/panel";
import { PanelMenuModule } from "primeng/panelmenu";
import { RadioButtonModule } from "primeng/radiobutton";
import { ScrollPanelModule } from "primeng/scrollpanel";
import { SelectButtonModule } from "primeng/selectbutton";
import { SidebarModule } from "primeng/sidebar";
import { TableModule } from "primeng/table";
import { TabViewModule } from "primeng/tabview";
import { ToastModule } from "primeng/toast";
import { ToolbarModule } from "primeng/toolbar";
import { TooltipModule } from "primeng/tooltip";
import { FieldsetModule } from "primeng/fieldset";
import { CaptchaModule } from "primeng/captcha";
import {TreeTableModule} from 'primeng/treetable';
import {InputTextareaModule} from 'primeng/inputtextarea';
import { RatingModule } from 'primeng/rating';
import { TriStateCheckboxModule } from 'primeng/tristatecheckbox';
import {DataViewModule} from 'primeng/dataview';
import { ProgressSpinnerModule } from 'primeng/progressspinner';



// import { SplitButtonModule } from "primeng/splitbutton";
// import { AutoCompleteModule } from "primeng/autocomplete";
import { MultiSelectModule } from "primeng/multiselect";
// import { StepsModule } from "primeng/steps";
// import { VirtualScrollerModule } from "primeng/virtualscroller";
// import { MessagesModule } from "primeng/messages";
// import { MessageModule } from "primeng/message";

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ToolbarModule,
    ButtonModule,
    // SplitButtonModule,
    PanelModule,
    ScrollPanelModule,
    PanelMenuModule,
    MenuModule,
    CalendarModule,
    // AutoCompleteModule,
    MultiSelectModule,
    CheckboxModule,
    InputMaskModule,
    TableModule,
    InputSwitchModule,
    TooltipModule,
    // StepsModule,
    DropdownModule,
    TabViewModule,
    FileUploadModule,
    // VirtualScrollerModule,
    DragDropModule,
    ToastModule,
    DynamicDialogModule,
    InputTextModule,
    // MessageModule,
    // MessagesModule,
    // RadioButtonModule,
    ConfirmDialogModule,
    AccordionModule,
    SelectButtonModule,
    DialogModule,
    OverlayPanelModule,
    CardModule,
    ChartModule,
    EditorModule,
    SidebarModule,
    FieldsetModule,
    CaptchaModule,
    TreeTableModule,
    InputTextareaModule,
    RatingModule,
    TriStateCheckboxModule,
    DataViewModule,
    ProgressSpinnerModule
  ],
  exports: [
    CommonModule,
    ToolbarModule,
    ButtonModule,
    // SplitButtonModule,
    PanelModule,
    ScrollPanelModule,
    PanelMenuModule,
    MenuModule,
    CalendarModule,
    // AutoCompleteModule, //
    MultiSelectModule, //
    CheckboxModule,
    InputMaskModule,
    TableModule,
    InputSwitchModule,
    TooltipModule,
    // StepsModule,
    DropdownModule,
    TabViewModule,
    FileUploadModule,
    // VirtualScrollerModule,
    DragDropModule,
    ToastModule,
    DynamicDialogModule,
    InputTextModule,
    // MessageModule,
    // MessagesModule,
    RadioButtonModule, //
    ConfirmDialogModule,
    AccordionModule,
    SelectButtonModule,
    DialogModule,
    OverlayPanelModule, //
    CardModule,
    ChartModule,
    EditorModule,
    SidebarModule,
    FieldsetModule,
    CaptchaModule,
    TreeTableModule,
    InputTextareaModule,
    RatingModule,
    TriStateCheckboxModule,
    DataViewModule,
    ProgressSpinnerModule
  ],
  providers: [],
})
export class PrimeNgModule {}
